export default __webpack_public_path__ + "go.67c9f032.png";